<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const CasinoIcon = getIcon("CasinoIcon");
export let size = 23;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof CasinoIcon === 'string'}
	<img src={CasinoIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof CasinoIcon === 'function'}
	<svelte:component this={CasinoIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
